<template>
    <div @keydown.enter="submitForm">
        <div class="form-group" v-for="(input, name, inputIndex) in form" :key="inputIndex">
            <Input
                :inputClass="input.inputClass"
                :isValid="input.required ? input.isValid : true"
                :validationMessage="input.required ? input.validationMessage : ''"
                :type="input.type"
                :name="name"
                :label="input.label"
                :labelDescription="input.labelDescription"
                :required="input.required"
                :cleaveOptions="input.cleaveOptions"
                v-model="input.value"
                :suggestion="input.suggestion" />
        </div>
        <transition name="fade">
            <div class="error text_11" v-if="error">{{ error }}</div>
        </transition>
        <div class="form-group login-submit">
            <div class="button button--dark button--wide" @click="submitForm">
                {{ $t("lk_log_in") }}
            </div>
            <nuxt-link :to="{ name: 'lk-register', query: $route.query }" class="button button--text">{{
                $t("lk_register")
            }}</nuxt-link>
        </div>
    </div>
</template>

<script>
import Input from "@/components/form/Input.vue";
import { createRetailCRM } from "../plugins/retailCRM.client";
import { computed } from "vue";

export default {
    name: "LoginByEmail",
    components: { Input },
    data() {
        return {
            error: "",
            form: {
                email: {
                    label: this.$i18n.t("el_mail"),
                    required: true,
                    isValid: true,
                    validationMessage: "",
                    value: "",
                    inputClass: "black-border",
                },
                password: {
                    label: this.$i18n.t("password"),
                    type: "password",
                    required: true,
                    isValid: true,
                    validationMessage: "",
                    value: "",
                    inputClass: "black-border",
                },
            },
        };
    },
    watch: {
        langust() {
            this.form.email.label = this.$i18n.t("el_mail");
            this.form.password.label = this.$i18n.t("password");
        },
    },
    methods: {
        submitForm() {
            this.error = "";
            for (const key in this.form) {
                if (Object.hasOwnProperty.call(this.form, key)) {
                    const element = this.form[key];
                    element.isValid = true;
                    element.validationMessage = "";
                }
            }

            this.$auth
                .loginWith("cookie", { data: { email: this.form.email.value, password: this.form.password.value } })
                .then((res) => {
                    if (res.data.success) {
                        this.$gtm.push({
                            event: "GAevent",
                            eventCategory: "user",
                            eventAction: "send",
                            eventLabel: "entrance",
                            userId: res.data.data.retail_id,
                        });

                        createRetailCRM(this.$auth.user?.retail_id || null, this.$auth.user.name);
                        this.$grom.checkEverCookie()

                        // if (this.$route.query.redirect === "zakaz") {
                        //     this.$router.push("/zakaz");
                        // } else {
                        //     this.$router.push("/lk");
                        // }
                    } else {
                        this.error = res.data.error;
                        this.processError(res.data.error);
                    }
                })
                .catch((error) => {
                    this.processError(error);
                });
        },
        processError(error) {
            this.isLoading = false;
            if (error.response) {
                if (error.response.status == 406) {
                    let notValidFields = error.response.data.data;
                    for (const key in notValidFields) {
                        if (notValidFields.hasOwnProperty(key)) {
                            const element = notValidFields[key];
                            let name = key.split(".").length > 1 ? key.split(".")[1] : key;
                            if (this.form[name]) {
                                this.form[name].isValid = false;
                                this.form[name].validationMessage = Array.isArray(element) ? element[0] : element;
                            }
                        }
                    }
                    let first_key = Object.keys(notValidFields)[0];
                    let first_name = first_key.split(".").length > 1 ? first_key.split(".")[1] : first_key;
                    let elem = document.querySelector(`[name="${first_name}"]`);
                    if (elem) {
                        elem.scrollIntoView({ block: "center", behavior: "smooth" });
                        elem.focus();
                    }
                } else {
                    console.log(`error.response.error =>`, error.response.error);
                    if (error.response.data.error) {
                        this.error = error.response.data.error;
                    } else {
                        this.error = error;
                    }
                }
            }
        },
    },
};
</script>

<style scoped></style>
